import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme } from '@mui/material';

export const inputLabel: {
  defaultProps?: ComponentsProps['MuiInputLabel'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiInputLabel'];
  variants?: ComponentsVariants<Theme>['MuiInputLabel'];
} = {
  variants: [
    {
      props: {},
      style({ theme }) {
        return {
          '&.Mui-focused': {
            color: theme.palette.grey[800]
          }
        };
      }
    }
  ],
  styleOverrides: {
    root({ theme }) {
      return {
        transition: `${theme.transitions.duration.shortest}ms`
      };
    }
  }
};
